module.exports = __webpack_public_path__ + "static/media/preview.cd1c902c.png";